export default function Footer(){
    return(
<>
<footer className="bottom col-xs-12 foot_block" id="footer">
<div className="container">
    <div className="row comm_cont justify-content-center">
        <div className="col-lg-5 align-self-center">
            <div className="footer-logo">
                <a href="index.php" className="f-logo">
                    <img src="img/the-grand-logo.png" alt="" className="footer-logo-img" />
                </a>
            </div>
        </div>
        <div className="col-lg-6">
            <div className="footer-right-items">
                <div className="add_head">
                    <h4 className="brand-name-footer">The Grand New Delhi</h4>
                    <p className="footer-address">Nelson Mandela Marg, Pocket 4, Vasant Kunj, New Delhi, Delhi - 110070</p>
                </div>
                <div className="address_block">
                        <div className="add_cont">
                            <ul className="">
                                <li>
                                    <div className="footer-detail">
                                        <span>
                                            <a href="mailto:reservation@thegrandnewdelhi.com">reservation@thegrandnewdelhi.com</a> &nbsp;&nbsp;| &nbsp;&nbsp; <a href="tel:+911147661200">+91-1147 66 1200</a>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                </div>
                <div className="social_block">
                    <div className="social_head"><p>Get In Touch</p></div>
                    <div className="social_cont">
                        <div className="socialIcon">
                            <a className="social-fb" href="#" target="_blank">
                                <img src="img/tripadvisor.png" alt="" className="footer-social" />
                            </a>
                            <a className="social-fb" href="#" target="_blank">
                                <img src="img/instagram.png" alt="" className="footer-social" />
                            </a>
                            <a className="social-fb" href="#" target="_blank">
                                <img src="img/facebook.png" alt="" className="footer-social" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-xs-12 footer-row footer_navbar_wrapper">
            <div className="clearfix">
                <nav className="footer_navbar scroll">
                    <ul className="nav navbar-nav">
                        <li className="second-li"><a href="index.php">Home</a></li>
                        <li className="second-li"><a href="about.php">About Us</a></li>
                        <li className="second-li"><a href="rooms.php">Our Hotel</a></li>
                        <li className="second-li"><a href="gallery.php">Gallery</a></li>
                        <li className="second-li"><a href="#">Awards</a></li>
                        <li className="second-li"><a href="offers.php">Offers Blog</a></li>
                        <li className="second-li"><a href="#">Disclaimer</a></li>
                        <li className="second-li"><a href="contact.php">Contact Us</a></li>
                        <li className="second-li"><a href="service-apratments.hp">Service Apartments</a></li>
                        <li className="second-li"><a href="#">Covid 19 Updates </a></li>
                        <li className="second-li"><a href="#">Find Reservation</a></li>
                    </ul>
                </nav>
            </div>
        </div>
       
    </div>
</div>
</footer>

</>
);
}